import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IMyDpOptions, IMyInputFieldChanged } from 'mydatepicker';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DateService } from 'src/app/date.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { IsViewEditpayorequired, PayorRequiredIDBO } from '../employee.model';
import { EmployeeService } from '../employee.service';

@Component({
  selector: 'app-payor-required-ids-edit',
  templateUrl: './payor-required-ids-edit.component.html',
  styleUrls: ['./payor-required-ids-edit.component.scss']
})
export class PayorRequiredIdsEditComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @Input() payoRequiredViewEditdata: IsViewEditpayorequired;
  @Output() IsViewEditpayorequired = new EventEmitter<IsViewEditpayorequired>();
  PayorRequired: PayorRequiredIDBO = new PayorRequiredIDBO();
  PayorRequiredLst: PayorRequiredIDBO[];
  deleteid: string ='00000000-0000-0000-0000-000000000000';
  GroupLst: [{ Key: string, Value: string }]
  PayorRequiredForm: FormGroup;
  //////////////////////////Date picker Options/////////////////////////////////////////////////////////////////////////
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    showClearDateBtn: false,
    editableDateField: true
  };
  constructor(public formBuilder: FormBuilder,public dateservice: DateService, public toastrService: ToastrService,public global: GlobalComponent, public Employeeservice: EmployeeService, ) {
    this.PayorRequiredForm =this.formBuilder.group({
      PayorName: new FormControl('', [Validators.required]),  
      billingPayerRequiredId: new FormControl('', [Validators.required]),
   //   Enddate: [' '],
    });
   }


  ngOnInit(): void {
      
    if (this.payoRequiredViewEditdata.payorRequiredId != '00000000-0000-0000-0000-000000000000') {
      if (this.payoRequiredViewEditdata.payorActiotype == 'edit') {
       
       this.PayorRequired.startDate = this.payoRequiredViewEditdata.payorRequired[0].startDate;
        this.PayorRequired = this.payoRequiredViewEditdata.payorRequired.filter(p => p.id == this.payoRequiredViewEditdata.payorRequiredId)[0];
        document.getElementById("modelopen").click();
      }
      else {
        this.deleteid = this.payoRequiredViewEditdata.payorRequiredId
        document.getElementById("deletemodal").click();
      }

     }
     else {
       this.PayorRequired.id = '00000000-0000-0000-0000-000000000000';
      document.getElementById("modelopen").click();

     }
    this.getpayor();
  }

 
  back() {
    this.IsViewEditpayorequired.emit
    ({ isView: true, isEdit: false, 
      isEditPayorRequired: false, employeeId: this.payoRequiredViewEditdata.employeeId,
       payorRequiredId: '00000000-0000-0000-0000-000000000000', payorRequired: this.payoRequiredViewEditdata.payorRequired,
       payorActiotype: "" })
  }
 
  //////////////////////////////////Date function/////////////////////////////////////////////////////////////////////
  newdates(event, type, name) {
 
    if (type == "inputchage") {
      if (name == 'start') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.PayorRequired.startDate = val1;
        }
      }
      if (name == 'end') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.PayorRequired.endDate = val1;
        }
      }

    }
    if (type == "datechagned") {
      if (name == 'start') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.PayorRequired.startDate = val1;
        }
      }
      if (name == 'end') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.PayorRequired.endDate = val1;
        }
      }
     

    }
  }

  getpayor() {
    let params = new URLSearchParams();
    this.Employeeservice.getpayor().pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: string, Value: string }]) => {
      this.GroupLst = data;
    })
  }


  disabledsavebutton:boolean=false;
  savePayorRequired(val) {
    this.disabledsavebutton=true;
    let savevalue = JSON.parse(JSON.stringify(val))
    if (savevalue.startDate != null && savevalue.endDate) {
      if (new Date(savevalue.startDate).getTime() > new Date(savevalue.endDate).getTime()) {
        this.toastrService.error('End date shold greater than start date', 'Warning');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
        this.disabledsavebutton=false;
        return
      }
    }

    if (savevalue.id == '00000000-0000-0000-0000-000000000000' || savevalue.id == null) {
      savevalue.id == '00000000-0000-0000-0000-000000000000';
      savevalue.employeeId = this.payoRequiredViewEditdata.employeeId;

    }

    savevalue.startDate = savevalue.startDate != null ? (new Date(savevalue.startDate + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z","") : null;
    console.log(savevalue.endDate,"eeeeeeeeeennnnnnnnnnnn")
    savevalue.endDate = ( savevalue.endDate != null&& savevalue.endDate!=undefined &&savevalue.endDate!='')? (new Date(savevalue.endDate + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z","") : null;
   
    savevalue.payerId = savevalue.payerId
    savevalue.employeeId = this.payoRequiredViewEditdata.employeeId;
    if (this.PayorRequired.id == '00000000-0000-0000-0000-000000000000') {
      this.Employeeservice.savePayorRequired(savevalue).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
        document.getElementById("modelopen").click();
        this.disabledsavebutton=false;
        this.toastrService.success('Employee created successfully!');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
        this.back()
      },
        (err: any) => {
          this.disabledsavebutton=false;
          this.toastrService.error(
            err,
            'Error');
        })
    }
    if (this.PayorRequired.id != '00000000-0000-0000-0000-000000000000') {
     

      this.Employeeservice.savePayorRequired(savevalue).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
        document.getElementById("modelopen").click();
        this.disabledsavebutton=false;
        this.toastrService.success('Employee PayorRequiredId updated successfully!');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);

        this.back();
      }, (err: HttpErrorResponse) => {
        this.disabledsavebutton=false;
        // this.disabledsavebutton=false;
        this.toastrService.error(
          err.error,
          'Error');
      });
    }
  }
 
  ///////////////////////////////////////////delete payor///////////////////////////////////////////////////////
  // deletepayor() {
  //   let params = new URLSearchParams();
  //   params.append("payorId", this.deleteid);
  //   this.Employeeservice.deletepayorReqiured(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  //     this.toastrService.success('Employee PayorRequiredId deleted successfully!');
  //     setTimeout(() => {
  //       this.toastrService.clear();
  //     }, 8000);
  //     this.back();
  //   },
  //     (err: HttpErrorResponse) => {
  //       this.toastrService.error(
  //         err.error,
  //         'Error');
  //     })
  // }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
  }


